import { createContext, useState } from 'react'

/**
 * @param {{
 *     accessToken: string,
 *     refreshToken: string,
 *     providerToken: string | null,
 *     user: {
 *       id: number,
 *       firstName: string,
 *       lastName: string,
 *       email: string,
 *       role: string,
 *       clientId: number,
 *       clientKey: string | null,
 *       location: string | null,
 *       userClients: unknown[] | null,
 *       permissions: string[]
 *     }
 * }} auth //this is the auth data structure for the auth state below
 */

export const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({})
  const [activeClientId, setActiveClientId] = useState(null)
  const [clientModal, setClientModal] = useState(false)
  const [userModal, setUserModal] = useState(false)
  const [ssccModal, setSsccModal] = useState(false)
  const [sgtinModal, setSgtinModal] = useState(false)
  const [allClients, setAllClients] = useState([])
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [closeLogoutForm, setCloseLogoutForm] = useState(false)
  const [closeLogoutFormMobile, setCloseLogoutFormMobile] = useState(false)
  const [loading, setLoading] = useState(false)
  const [closeErrorFalsh, setCloseErrorFalsh] = useState(false)
  const [editUserModal, setEditUserModal] = useState(false)
  const [editUser, setEditUser] = useState({})
  const [editUserRoleModal, setEditUserRoleModal] = useState(false)

  const updateClientId = (newClientId) => {
    setAuth(prev => ({
      ...prev,
      user: {
        ...prev.user,
        clientId: newClientId
      }
    }))
  }

  const updateClientEmail = (selectedEmail) => {
		setAuth((prev) => ({
			...prev,
			user: {
				...prev.user,
				clientEmail: selectedEmail,
			},
		}));
  };

  const updateClientLocation = (selectedGLN) => {
		setAuth((prev) => ({
			...prev,
			user: {
				...prev.user,
				location: selectedGLN,
			},
		}));
  };

  const updateUserObj = (userObj) => {
    setAuth(prev => ({
      ...prev,
      user: userObj
    }))
  }

  return (
		<AuthContext.Provider
			value={{
				auth,
				setAuth,
				clientModal,
				setClientModal,
				userModal,
				setUserModal,
				ssccModal,
				setSsccModal,
				sgtinModal,
				setSgtinModal,
				allClients,
				setAllClients,
				latitude,
				setLatitude,
				longitude,
				setLongitude,
				closeLogoutForm,
				setCloseLogoutForm,
				closeLogoutFormMobile,
				setCloseLogoutFormMobile,
				loading,
				setLoading,
				closeErrorFalsh,
				setCloseErrorFalsh,
				editUserModal,
				setEditUserModal,
				editUser,
				setEditUser,
				editUserRoleModal,
				setEditUserRoleModal,
				activeClientId,
				setActiveClientId,
				updateClientId,
				updateUserObj,
				updateClientLocation,
				updateClientEmail,
			}}
		>
			{children}
		</AuthContext.Provider>
  );
}
